export const actMathWorksheets = [
  // ─── PRE-ALGEBRA ───────────────────────────────────────────────────────────
  {
    id: 'act-pa-whole-numbers',
    title: 'ACT Math: Whole Numbers & Operations',
    description: 'Multi-step calculations, order of operations (PEMDAS), large number arithmetic, and estimation — exactly as tested on the ACT.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Pre-Algebra',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-pa-whole-numbers.pdf',
    thumbnailUrl: 'https://public.readdy.ai/ai/img_res/3ea774f359afb914ea1a1e6933199d98.jpg'
  },
  {
    id: 'act-pa-fractions',
    title: 'ACT Math: Fractions',
    description: 'Add, subtract, multiply, and divide fractions; convert mixed numbers; compare fractions; and solve fraction word problems in ACT format.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Pre-Algebra',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-pa-fractions.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20fractions%20operations%20mixed%20numbers%20improper%20fractions%20comparing%20fractions%20multiple%20choice%20test%20format%20professional%20layout%20clean%20white%20background%20neat%20columns&width=400&height=500&seq=actws002&orientation=portrait'
  },
  {
    id: 'act-pa-decimals',
    title: 'ACT Math: Decimals',
    description: 'Decimal operations, place value, rounding, converting between decimals and fractions, and real-world decimal applications for ACT.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Pre-Algebra',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-pa-decimals.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20decimals%20place%20value%20rounding%20converting%20fractions%20to%20decimals%20operations%20multiple%20choice%20standardized%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actws003&orientation=portrait'
  },
  {
    id: 'act-pa-percents',
    title: 'ACT Math: Percents',
    description: 'Percent of a number, percent increase/decrease, converting between percents/decimals/fractions, and real-world percent problems.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Pre-Algebra',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-pa-percents.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20percents%20percent%20increase%20decrease%20discount%20tax%20tip%20word%20problems%20multiple%20choice%20test%20format%20professional%20standardized%20layout%20clean%20background&width=400&height=500&seq=actws004&orientation=portrait'
  },
  {
    id: 'act-pa-ratios-proportions',
    title: 'ACT Math: Ratios & Proportions',
    description: 'Set up and solve proportions, unit rates, scale drawings, similar figures, and unit conversions — all in ACT multiple-choice format.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Pre-Algebra',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-pa-ratios-proportions.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20ratios%20proportions%20unit%20rates%20scale%20drawings%20cross%20multiplication%20word%20problems%20multiple%20choice%20standardized%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actws005&orientation=portrait'
  },
  {
    id: 'act-pa-integers',
    title: 'ACT Math: Integers & Operations',
    description: 'Operations with positive and negative integers, absolute value, number line problems, and integer word problems for ACT.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Pre-Algebra',
    difficulty: 'Advanced' as const,
    pages: 5,
    isFree: false,
    downloadUrl: '/downloads/act-pa-integers.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20integers%20negative%20numbers%20absolute%20value%20number%20line%20operations%20multiple%20choice%20test%20format%20professional%20standardized%20layout%20clean%20white%20background&width=400&height=500&seq=actws006&orientation=portrait'
  },
  {
    id: 'act-pa-factors-multiples',
    title: 'ACT Math: Factors & Multiples',
    description: 'Prime factorization, GCF, LCM, prime vs. composite numbers, divisibility rules, and number theory problems in ACT format.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Pre-Algebra',
    difficulty: 'Advanced' as const,
    pages: 5,
    isFree: false,
    downloadUrl: '/downloads/act-pa-factors-multiples.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20factors%20multiples%20prime%20factorization%20GCF%20LCM%20divisibility%20rules%20number%20theory%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actws007&orientation=portrait'
  },
  {
    id: 'act-pa-number-properties',
    title: 'ACT Math: Number Properties',
    description: 'Commutative, associative, and distributive properties; even/odd rules; identity and inverse properties — applied in ACT-style problems.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Pre-Algebra',
    difficulty: 'Advanced' as const,
    pages: 5,
    isFree: false,
    downloadUrl: '/downloads/act-pa-number-properties.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20number%20properties%20distributive%20associative%20commutative%20even%20odd%20integers%20multiple%20choice%20standardized%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actws008&orientation=portrait'
  },
  {
    id: 'act-pa-basic-probability',
    title: 'ACT Math: Basic Probability',
    description: 'Simple and compound probability, independent events, probability with/without replacement, and probability word problems for ACT.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Pre-Algebra',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-pa-basic-probability.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20probability%20simple%20compound%20independent%20events%20replacement%20word%20problems%20multiple%20choice%20test%20format%20professional%20standardized%20layout%20clean%20background&width=400&height=500&seq=actws009&orientation=portrait'
  },
  {
    id: 'act-pa-data-interpretation',
    title: 'ACT Math: Data Interpretation',
    description: 'Mean, median, mode, range, reading bar graphs, line graphs, pie charts, and scatter plots — all in ACT multiple-choice format.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Pre-Algebra',
    difficulty: 'Advanced' as const,
    pages: 7,
    isFree: false,
    downloadUrl: '/downloads/act-pa-data-interpretation.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20data%20interpretation%20mean%20median%20mode%20bar%20graphs%20pie%20charts%20scatter%20plots%20statistics%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actws010&orientation=portrait'
  },

  // ─── ELEMENTARY ALGEBRA ────────────────────────────────────────────────────
  {
    id: 'act-ea-substitution',
    title: 'ACT Math: Substitution & Evaluating Expressions',
    description: 'Substitute values into algebraic expressions and formulas, evaluate with negative numbers and exponents, in ACT format.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Elementary Algebra',
    difficulty: 'Advanced' as const,
    pages: 5,
    isFree: false,
    downloadUrl: '/downloads/act-ea-substitution.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20substitution%20evaluating%20algebraic%20expressions%20variables%20formulas%20multiple%20choice%20test%20format%20professional%20standardized%20layout%20clean%20white%20background&width=400&height=500&seq=actws011&orientation=portrait'
  },
  {
    id: 'act-ea-word-problems',
    title: 'ACT Math: Setting Up Equations from Word Problems',
    description: 'Translate verbal descriptions into algebraic equations — sums, differences, products, consecutive integers, and real-world scenarios.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Elementary Algebra',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-ea-word-problems.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20word%20problems%20translating%20to%20equations%20algebraic%20expressions%20consecutive%20integers%20real%20world%20scenarios%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actws012&orientation=portrait'
  },
  {
    id: 'act-ea-linear-equations',
    title: 'ACT Math: Linear Equations in One Variable',
    description: 'Solve multi-step linear equations with distributive property, combining like terms, fractions, and decimals — ACT style.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Elementary Algebra',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-ea-linear-equations.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20linear%20equations%20one%20variable%20multi-step%20distributive%20property%20combining%20like%20terms%20fractions%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actws013&orientation=portrait'
  },
  {
    id: 'act-ea-absolute-value',
    title: 'ACT Math: Absolute Value Equations',
    description: 'Solve absolute value equations with one and two solutions, set up two-case equations, and apply to real-world contexts.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Elementary Algebra',
    difficulty: 'Advanced' as const,
    pages: 5,
    isFree: false,
    downloadUrl: '/downloads/act-ea-absolute-value.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20absolute%20value%20equations%20two%20cases%20solutions%20number%20line%20multiple%20choice%20test%20format%20professional%20standardized%20layout%20clean%20white%20background&width=400&height=500&seq=actws014&orientation=portrait'
  },
  {
    id: 'act-ea-inequalities',
    title: 'ACT Math: Linear Inequalities',
    description: 'Solve one-variable and compound inequalities, reverse inequality sign rules, and graph solutions on a number line.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Elementary Algebra',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-ea-inequalities.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20linear%20inequalities%20compound%20inequalities%20number%20line%20graphing%20solutions%20reverse%20sign%20rule%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actws015&orientation=portrait'
  },
  {
    id: 'act-ea-linear-two-variables',
    title: 'ACT Math: Linear Equations in Two Variables',
    description: 'Slope, y-intercept, slope-intercept form, standard form, x/y intercepts, parallel and perpendicular lines — ACT format.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Elementary Algebra',
    difficulty: 'Advanced' as const,
    pages: 7,
    isFree: false,
    downloadUrl: '/downloads/act-ea-linear-two-variables.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20linear%20equations%20two%20variables%20slope%20intercept%20form%20standard%20form%20parallel%20perpendicular%20lines%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actws016&orientation=portrait'
  },
  {
    id: 'act-ea-systems',
    title: 'ACT Math: Systems of Linear Equations',
    description: 'Solve systems by substitution and elimination; identify no solution, one solution, or infinitely many solutions.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Elementary Algebra',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-ea-systems.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20systems%20linear%20equations%20substitution%20elimination%20no%20solution%20infinite%20solutions%20multiple%20choice%20test%20format%20professional%20standardized%20layout%20clean%20background&width=400&height=500&seq=actws017&orientation=portrait'
  },
  {
    id: 'act-ea-polynomials',
    title: 'ACT Math: Polynomials — Add, Subtract, Multiply',
    description: 'Add and subtract polynomials, multiply using FOIL and distributive property, expand binomials and trinomials.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Elementary Algebra',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-ea-polynomials.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20polynomials%20FOIL%20multiply%20add%20subtract%20binomials%20trinomials%20expand%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actws018&orientation=portrait'
  },
  {
    id: 'act-ea-factoring',
    title: 'ACT Math: Factoring Polynomials',
    description: 'Factor using GCF, trinomials, difference of squares, perfect square trinomials, and factoring by grouping.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Elementary Algebra',
    difficulty: 'Advanced' as const,
    pages: 7,
    isFree: false,
    downloadUrl: '/downloads/act-ea-factoring.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20factoring%20polynomials%20GCF%20difference%20of%20squares%20perfect%20square%20trinomials%20grouping%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actws019&orientation=portrait'
  },
  {
    id: 'act-ea-quadratic-equations',
    title: 'ACT Math: Solving Quadratic Equations',
    description: 'Solve quadratics by factoring, square roots, and the quadratic formula; use the discriminant to determine solution types.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Elementary Algebra',
    difficulty: 'Advanced' as const,
    pages: 7,
    isFree: false,
    downloadUrl: '/downloads/act-ea-quadratic-equations.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20quadratic%20equations%20factoring%20quadratic%20formula%20discriminant%20square%20roots%20solutions%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actws020&orientation=portrait'
  },

  // ─── INTERMEDIATE ALGEBRA ──────────────────────────────────────────────────
  {
    id: 'act-ia-quadratic-formula',
    title: 'ACT Math: Quadratic Formula & Discriminant',
    description: 'Apply the quadratic formula to any quadratic; use the discriminant to classify solutions as real, repeated, or complex.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Intermediate Algebra',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-ia-quadratic-formula.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20quadratic%20formula%20discriminant%20complex%20solutions%20real%20repeated%20roots%20intermediate%20algebra%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actws021&orientation=portrait'
  },
  {
    id: 'act-ia-radical-expressions',
    title: 'ACT Math: Radical Expressions',
    description: 'Simplify radicals, add/subtract/multiply radicals, rationalize denominators, and work with cube roots.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Intermediate Algebra',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-ia-radical-expressions.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20radical%20expressions%20simplify%20rationalize%20denominator%20conjugate%20cube%20roots%20square%20roots%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actws022&orientation=portrait'
  },
  {
    id: 'act-ia-rational-expressions',
    title: 'ACT Math: Rational Expressions',
    description: 'Simplify, multiply, divide, add, and subtract rational expressions; identify domain restrictions.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Intermediate Algebra',
    difficulty: 'Advanced' as const,
    pages: 7,
    isFree: false,
    downloadUrl: '/downloads/act-ia-rational-expressions.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20rational%20expressions%20simplify%20multiply%20divide%20add%20subtract%20domain%20restrictions%20algebraic%20fractions%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actws023&orientation=portrait'
  },
  {
    id: 'act-ia-complex-numbers',
    title: 'ACT Math: Complex Numbers',
    description: 'Add, subtract, multiply, and divide complex numbers; simplify powers of i; find conjugates.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Intermediate Algebra',
    difficulty: 'Advanced' as const,
    pages: 5,
    isFree: false,
    downloadUrl: '/downloads/act-ia-complex-numbers.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20complex%20numbers%20imaginary%20unit%20i%20powers%20conjugate%20operations%20FOIL%20multiple%20choice%20test%20format%20professional%20standardized%20layout%20clean%20white%20background&width=400&height=500&seq=actws024&orientation=portrait'
  },
  {
    id: 'act-ia-functions',
    title: 'ACT Math: Functions & Function Notation',
    description: 'Evaluate functions, find domain and range, compose functions, and solve for x given f(x) — all in ACT format.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Intermediate Algebra',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-ia-functions.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20functions%20function%20notation%20domain%20range%20composition%20evaluate%20f%20of%20x%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actws025&orientation=portrait'
  },
  {
    id: 'act-ia-matrices',
    title: 'ACT Math: Matrices',
    description: 'Add, subtract, and multiply matrices; scalar multiplication; identify dimensions and elements.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Intermediate Algebra',
    difficulty: 'Advanced' as const,
    pages: 5,
    isFree: false,
    downloadUrl: '/downloads/act-ia-matrices.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20matrices%20operations%20add%20subtract%20multiply%20scalar%20dimensions%20elements%20rows%20columns%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actws026&orientation=portrait'
  },
  {
    id: 'act-ia-sequences-series',
    title: 'ACT Math: Sequences & Series',
    description: 'Arithmetic and geometric sequences, find nth terms, calculate partial sums, and identify common differences and ratios.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Intermediate Algebra',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-ia-sequences-series.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20sequences%20series%20arithmetic%20geometric%20nth%20term%20partial%20sums%20common%20difference%20ratio%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actws027&orientation=portrait'
  },
  {
    id: 'act-ia-logarithms',
    title: 'ACT Math: Logarithms',
    description: 'Evaluate logarithms, apply log properties (product, quotient, power rules), solve logarithmic equations.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Intermediate Algebra',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-ia-logarithms.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20logarithms%20log%20properties%20product%20quotient%20power%20rule%20solve%20equations%20evaluate%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actws028&orientation=portrait'
  },
  {
    id: 'act-ia-exponential-functions',
    title: 'ACT Math: Exponential Functions',
    description: 'Simplify exponential expressions, apply exponent rules, evaluate exponential functions, and model growth/decay.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Intermediate Algebra',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-ia-exponential-functions.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20exponential%20functions%20exponent%20rules%20growth%20decay%20simplify%20evaluate%20multiple%20choice%20test%20format%20professional%20standardized%20layout%20clean%20white%20background&width=400&height=500&seq=actws029&orientation=portrait'
  },
  {
    id: 'act-ia-systems-inequalities',
    title: 'ACT Math: Systems of Inequalities',
    description: 'Graph linear inequalities, identify solution regions, solve systems of inequalities, and test boundary points.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Intermediate Algebra',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-ia-systems-inequalities.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20systems%20inequalities%20graphing%20shading%20solution%20region%20boundary%20solid%20dashed%20lines%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actws030&orientation=portrait'
  },

  // ─── COORDINATE GEOMETRY ───────────────────────────────────────────────────
  {
    id: 'act-cg-number-line-midpoint',
    title: 'ACT Math: Number Line & Midpoint',
    description: 'Find distances on a number line, calculate midpoints in 1D and 2D, and solve for missing endpoints.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Coordinate Geometry',
    difficulty: 'Advanced' as const,
    pages: 5,
    isFree: false,
    downloadUrl: '/downloads/act-cg-number-line-midpoint.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20number%20line%20midpoint%20formula%20distance%20coordinate%20plane%20endpoints%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actws031&orientation=portrait'
  },
  {
    id: 'act-cg-distance-formula',
    title: 'ACT Math: Distance Formula',
    description: 'Calculate distances between two points using the distance formula; apply to horizontal, vertical, and diagonal segments.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Coordinate Geometry',
    difficulty: 'Advanced' as const,
    pages: 5,
    isFree: false,
    downloadUrl: '/downloads/act-cg-distance-formula.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20distance%20formula%20coordinate%20plane%20two%20points%20Pythagorean%20theorem%20horizontal%20vertical%20diagonal%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actws032&orientation=portrait'
  },
  {
    id: 'act-cg-slope-equations',
    title: 'ACT Math: Slope & Equations of Lines',
    description: 'Calculate slope, write equations in slope-intercept and point-slope form, convert between forms, and find intercepts.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Coordinate Geometry',
    difficulty: 'Advanced' as const,
    pages: 7,
    isFree: false,
    downloadUrl: '/downloads/act-cg-slope-equations.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20slope%20equations%20lines%20slope%20intercept%20point%20slope%20standard%20form%20intercepts%20coordinate%20plane%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actws033&orientation=portrait'
  },
  {
    id: 'act-cg-parallel-perpendicular',
    title: 'ACT Math: Parallel & Perpendicular Lines',
    description: 'Identify parallel and perpendicular lines by slope, write equations of parallel/perpendicular lines through given points.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Coordinate Geometry',
    difficulty: 'Advanced' as const,
    pages: 5,
    isFree: false,
    downloadUrl: '/downloads/act-cg-parallel-perpendicular.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20parallel%20perpendicular%20lines%20slope%20negative%20reciprocal%20equations%20coordinate%20plane%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actws034&orientation=portrait'
  },
  {
    id: 'act-cg-graphing-linear',
    title: 'ACT Math: Graphing Linear Equations',
    description: 'Find x- and y-intercepts, graph lines using slope and intercept, and identify lines from graphs.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Coordinate Geometry',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-cg-graphing-linear.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20graphing%20linear%20equations%20x%20intercept%20y%20intercept%20slope%20coordinate%20plane%20grid%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actws035&orientation=portrait'
  },
  {
    id: 'act-cg-graphing-quadratics',
    title: 'ACT Math: Graphing Quadratics & Parabolas',
    description: 'Find vertex, axis of symmetry, direction of opening, and intercepts of parabolas; use vertex form.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Coordinate Geometry',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-cg-graphing-quadratics.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20parabolas%20quadratic%20functions%20vertex%20axis%20of%20symmetry%20intercepts%20vertex%20form%20coordinate%20plane%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actws036&orientation=portrait'
  },
  {
    id: 'act-cg-circles',
    title: 'ACT Math: Circles on the Coordinate Plane',
    description: 'Write and interpret circle equations in standard form; find center, radius, and diameter from equations.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Coordinate Geometry',
    difficulty: 'Advanced' as const,
    pages: 5,
    isFree: false,
    downloadUrl: '/downloads/act-cg-circles.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20circles%20coordinate%20plane%20standard%20form%20center%20radius%20diameter%20equation%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actws037&orientation=portrait'
  },
  {
    id: 'act-cg-transformations',
    title: 'ACT Math: Transformations',
    description: 'Translations, reflections over axes and y=x, rotations, and dilations of points and figures on the coordinate plane.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Coordinate Geometry',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-cg-transformations.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20transformations%20translations%20reflections%20rotations%20dilations%20coordinate%20plane%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actws038&orientation=portrait'
  },
  {
    id: 'act-cg-graphing-inequalities',
    title: 'ACT Math: Graphing Inequalities',
    description: 'Graph linear inequalities, determine solid vs. dashed boundaries, shade correct regions, and test solution points.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Coordinate Geometry',
    difficulty: 'Advanced' as const,
    pages: 5,
    isFree: false,
    downloadUrl: '/downloads/act-cg-graphing-inequalities.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20graphing%20inequalities%20solid%20dashed%20boundary%20shading%20solution%20region%20coordinate%20plane%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actws039&orientation=portrait'
  },
  {
    id: 'act-cg-conics',
    title: 'ACT Math: Conics Overview',
    description: 'Identify circles, ellipses, parabolas, and hyperbolas from equations; find key features of each conic section.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Coordinate Geometry',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-cg-conics.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20conic%20sections%20circles%20ellipses%20parabolas%20hyperbolas%20identify%20equations%20features%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actws040&orientation=portrait'
  },

  // ─── PLANE GEOMETRY ────────────────────────────────────────────────────────
  {
    id: 'act-pg-angles-lines',
    title: 'ACT Math: Angles & Lines',
    description: 'Complementary, supplementary, vertical, and corresponding angles; parallel lines cut by a transversal; angle equations.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Plane Geometry',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-pg-angles-lines.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20angles%20lines%20parallel%20transversal%20complementary%20supplementary%20vertical%20corresponding%20alternate%20interior%20exterior%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actws041&orientation=portrait'
  },
  {
    id: 'act-pg-triangles',
    title: 'ACT Math: Triangles — Area, Perimeter & Types',
    description: 'Triangle area and perimeter, angle sum, isosceles and equilateral triangles, exterior angles, and triangle classification.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Plane Geometry',
    difficulty: 'Advanced' as const,
    pages: 7,
    isFree: false,
    downloadUrl: '/downloads/act-pg-triangles.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20triangles%20area%20perimeter%20angle%20sum%20isosceles%20equilateral%20exterior%20angles%20classification%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actws042&orientation=portrait'
  },
  {
    id: 'act-pg-pythagorean',
    title: 'ACT Math: Pythagorean Theorem',
    description: 'Apply the Pythagorean theorem to find missing sides; recognize Pythagorean triples; solve real-world right triangle problems.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Plane Geometry',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-pg-pythagorean.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20Pythagorean%20theorem%20right%20triangles%20missing%20sides%20triples%20real%20world%20applications%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actws043&orientation=portrait'
  },
  {
    id: 'act-pg-similar-congruent',
    title: 'ACT Math: Similar & Congruent Triangles',
    description: 'Scale factors, proportional sides, congruence criteria (SSS, SAS, ASA), similarity criteria (AA, SAS, SSS), and area ratios.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Plane Geometry',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-pg-similar-congruent.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20similar%20congruent%20triangles%20scale%20factor%20proportional%20sides%20SSS%20SAS%20ASA%20AA%20criteria%20area%20ratio%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actws044&orientation=portrait'
  },
  {
    id: 'act-pg-quadrilaterals',
    title: 'ACT Math: Quadrilaterals',
    description: 'Area and perimeter of rectangles, squares, parallelograms, trapezoids, and rhombuses; angle properties of quadrilaterals.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Plane Geometry',
    difficulty: 'Advanced' as const,
    pages: 7,
    isFree: false,
    downloadUrl: '/downloads/act-pg-quadrilaterals.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20quadrilaterals%20rectangles%20squares%20parallelograms%20trapezoids%20rhombuses%20area%20perimeter%20angles%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actws045&orientation=portrait'
  },
  {
    id: 'act-pg-circles',
    title: 'ACT Math: Circles — Area, Circumference, Arcs & Sectors',
    description: 'Circumference, area, arc length, sector area, central angles, inscribed angles, and concentric circles.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Plane Geometry',
    difficulty: 'Advanced' as const,
    pages: 7,
    isFree: false,
    downloadUrl: '/downloads/act-pg-circles.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20circles%20circumference%20area%20arc%20length%20sector%20central%20angle%20inscribed%20angle%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actws046&orientation=portrait'
  },
  {
    id: 'act-pg-3d-solids',
    title: 'ACT Math: 3D Solids — Volume & Surface Area',
    description: 'Volume and surface area of prisms, cylinders, spheres, cones, and pyramids; find missing dimensions.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Plane Geometry',
    difficulty: 'Advanced' as const,
    pages: 7,
    isFree: false,
    downloadUrl: '/downloads/act-pg-3d-solids.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%203D%20solids%20volume%20surface%20area%20prisms%20cylinders%20spheres%20cones%20pyramids%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actws047&orientation=portrait'
  },
  {
    id: 'act-pg-composite-figures',
    title: 'ACT Math: Composite Figures',
    description: 'Find area and volume of composite shapes by adding or subtracting basic figures; multi-step geometry problems.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Plane Geometry',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-pg-composite-figures.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20composite%20figures%20combined%20shapes%20area%20volume%20add%20subtract%20basic%20shapes%20multi-step%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actws048&orientation=portrait'
  },
  {
    id: 'act-pg-coordinate-proofs',
    title: 'ACT Math: Coordinate Geometry Proofs',
    description: 'Use distance, midpoint, and slope formulas to classify quadrilaterals, prove parallelism, and verify geometric properties.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Plane Geometry',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-pg-coordinate-proofs.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20coordinate%20geometry%20proofs%20distance%20midpoint%20slope%20classify%20quadrilaterals%20parallel%20perpendicular%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actws049&orientation=portrait'
  },
  {
    id: 'act-pg-geometric-reasoning',
    title: 'ACT Math: Geometric Reasoning & Proofs',
    description: 'Apply definitions, postulates, and theorems to draw conclusions; identify congruent/similar figures; multi-step reasoning.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Plane Geometry',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-pg-geometric-reasoning.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20geometric%20reasoning%20proofs%20definitions%20postulates%20theorems%20congruent%20similar%20figures%20logic%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actws050&orientation=portrait'
  },

  // ─── TRIGONOMETRY ──────────────────────────────────────────────────────────
  {
    id: 'act-trig-sohcahtoa',
    title: 'ACT Math: Right Triangle Trig (SOH-CAH-TOA)',
    description: 'Apply sine, cosine, and tangent ratios to find missing sides and angles in right triangles — ACT format.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Trigonometry',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-trig-sohcahtoa.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20right%20triangle%20trigonometry%20SOH%20CAH%20TOA%20sine%20cosine%20tangent%20missing%20sides%20angles%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actws051&orientation=portrait'
  },
  {
    id: 'act-trig-special-values',
    title: 'ACT Math: Trig Ratios & Special Values',
    description: 'Exact values for 30°, 45°, 60°; reciprocal functions (csc, sec, cot); cofunction identities and special angle patterns.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Trigonometry',
    difficulty: 'Advanced' as const,
    pages: 5,
    isFree: false,
    downloadUrl: '/downloads/act-trig-special-values.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20trigonometric%20special%20values%2030%2045%2060%20degrees%20exact%20values%20reciprocal%20functions%20cosecant%20secant%20cotangent%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actws052&orientation=portrait'
  },
  {
    id: 'act-trig-solving-right-triangles',
    title: 'ACT Math: Solving Right Triangles',
    description: 'Find all missing sides and angles of right triangles using trig ratios, inverse trig, and the Pythagorean theorem.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Trigonometry',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-trig-solving-right-triangles.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20solving%20right%20triangles%20missing%20sides%20angles%20inverse%20trig%20Pythagorean%20theorem%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actws053&orientation=portrait'
  },
  {
    id: 'act-trig-law-of-sines',
    title: 'ACT Math: Law of Sines',
    description: 'Apply the Law of Sines to non-right triangles (AAS, ASA, SSA); find missing sides and angles.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Trigonometry',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-trig-law-of-sines.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20law%20of%20sines%20non-right%20triangles%20AAS%20ASA%20SSA%20missing%20sides%20angles%20proportions%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actws054&orientation=portrait'
  },
  {
    id: 'act-trig-law-of-cosines',
    title: 'ACT Math: Law of Cosines',
    description: 'Apply the Law of Cosines to find missing sides (SAS) and angles (SSS) in non-right triangles.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Trigonometry',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-trig-law-of-cosines.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20law%20of%20cosines%20SAS%20SSS%20non-right%20triangles%20missing%20sides%20angles%20generalized%20Pythagorean%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actws055&orientation=portrait'
  },
  {
    id: 'act-trig-unit-circle',
    title: 'ACT Math: Unit Circle Basics',
    description: 'Coordinates on the unit circle, trig values at key angles (0°–360°), quadrant sign patterns, and reference angles.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Trigonometry',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-trig-unit-circle.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20unit%20circle%20coordinates%20key%20angles%20quadrants%20reference%20angles%20sine%20cosine%20values%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actws056&orientation=portrait'
  },
  {
    id: 'act-trig-identities',
    title: 'ACT Math: Trigonometric Identities',
    description: 'Pythagorean identities, reciprocal identities, quotient identities, cofunction identities, and even-odd identities.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Trigonometry',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-trig-identities.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20trigonometric%20identities%20Pythagorean%20reciprocal%20quotient%20cofunction%20even%20odd%20simplify%20verify%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actws057&orientation=portrait'
  },
  {
    id: 'act-trig-graphing',
    title: 'ACT Math: Graphing Trigonometric Functions',
    description: 'Amplitude, period, phase shift, and vertical shift of sine, cosine, and tangent graphs; match equations to graphs.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Trigonometry',
    difficulty: 'Advanced' as const,
    pages: 6,
    isFree: false,
    downloadUrl: '/downloads/act-trig-graphing.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20graphing%20trigonometric%20functions%20amplitude%20period%20phase%20shift%20vertical%20shift%20sine%20cosine%20tangent%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actws058&orientation=portrait'
  },
  {
    id: 'act-trig-inverse',
    title: 'ACT Math: Inverse Trigonometric Functions',
    description: 'Evaluate arcsin, arccos, and arctan; find angles from ratios; apply inverse trig to solve right triangle problems.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Trigonometry',
    difficulty: 'Advanced' as const,
    pages: 5,
    isFree: false,
    downloadUrl: '/downloads/act-trig-inverse.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20inverse%20trigonometric%20functions%20arcsin%20arccos%20arctan%20evaluate%20angles%20from%20ratios%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actws059&orientation=portrait'
  },
  {
    id: 'act-trig-applications',
    title: 'ACT Math: Trig Applications & Word Problems',
    description: 'Angle of elevation/depression, height and distance problems, navigation, and real-world trig applications.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Trigonometry',
    difficulty: 'Advanced' as const,
    pages: 7,
    isFree: false,
    downloadUrl: '/downloads/act-trig-applications.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20worksheet%20trigonometry%20applications%20angle%20elevation%20depression%20height%20distance%20word%20problems%20real%20world%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actws060&orientation=portrait'
  },

  // ─── FULL DOMAIN REVIEW PACKS ──────────────────────────────────────────────
  {
    id: 'act-review-pre-algebra',
    title: 'ACT Math: Pre-Algebra Full Review',
    description: 'Comprehensive review of all Pre-Algebra topics: whole numbers, fractions, decimals, percents, ratios, integers, probability, and data.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Pre-Algebra',
    difficulty: 'Advanced' as const,
    pages: 14,
    isFree: false,
    downloadUrl: '/downloads/act-review-pre-algebra.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20pre-algebra%20full%20review%20comprehensive%20all%20topics%20fractions%20decimals%20percents%20ratios%20probability%20data%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actws061&orientation=portrait'
  },
  {
    id: 'act-review-elementary-algebra',
    title: 'ACT Math: Elementary Algebra Full Review',
    description: 'Complete review of all Elementary Algebra topics: equations, inequalities, systems, polynomials, factoring, and quadratics.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Elementary Algebra',
    difficulty: 'Advanced' as const,
    pages: 16,
    isFree: false,
    downloadUrl: '/downloads/act-review-elementary-algebra.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20elementary%20algebra%20full%20review%20equations%20inequalities%20systems%20polynomials%20factoring%20quadratics%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actws062&orientation=portrait'
  },
  {
    id: 'act-review-intermediate-algebra',
    title: 'ACT Math: Intermediate Algebra Full Review',
    description: 'Full review of Intermediate Algebra: quadratic formula, radicals, rational expressions, complex numbers, functions, matrices, sequences, logs, and exponentials.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Intermediate Algebra',
    difficulty: 'Advanced' as const,
    pages: 18,
    isFree: false,
    downloadUrl: '/downloads/act-review-intermediate-algebra.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20intermediate%20algebra%20full%20review%20quadratic%20formula%20radicals%20rational%20expressions%20complex%20numbers%20functions%20matrices%20sequences%20logarithms%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actws063&orientation=portrait'
  },
  {
    id: 'act-review-coordinate-geometry',
    title: 'ACT Math: Coordinate Geometry Full Review',
    description: 'Complete review of Coordinate Geometry: distance, midpoint, slope, lines, parabolas, circles, transformations, inequalities, and conics.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Coordinate Geometry',
    difficulty: 'Advanced' as const,
    pages: 16,
    isFree: false,
    downloadUrl: '/downloads/act-review-coordinate-geometry.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20coordinate%20geometry%20full%20review%20distance%20midpoint%20slope%20lines%20parabolas%20circles%20transformations%20conics%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actws064&orientation=portrait'
  },
  {
    id: 'act-review-plane-geometry',
    title: 'ACT Math: Plane Geometry Full Review',
    description: 'Full review of Plane Geometry: angles, triangles, Pythagorean theorem, similarity, quadrilaterals, circles, 3D solids, and composite figures.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Plane Geometry',
    difficulty: 'Advanced' as const,
    pages: 18,
    isFree: false,
    downloadUrl: '/downloads/act-review-plane-geometry.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20plane%20geometry%20full%20review%20angles%20triangles%20Pythagorean%20theorem%20similarity%20quadrilaterals%20circles%203D%20solids%20composite%20figures%20multiple%20choice%20test%20format%20professional%20clean%20white%20background&width=400&height=500&seq=actws065&orientation=portrait'
  },
  {
    id: 'act-review-trigonometry',
    title: 'ACT Math: Trigonometry Full Review',
    description: 'Complete review of all Trig topics: SOH-CAH-TOA, special values, solving triangles, Law of Sines/Cosines, unit circle, identities, and graphing.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Trigonometry',
    difficulty: 'Advanced' as const,
    pages: 16,
    isFree: false,
    downloadUrl: '/downloads/act-review-trigonometry.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20math%20trigonometry%20full%20review%20SOH%20CAH%20TOA%20special%20values%20law%20of%20sines%20cosines%20unit%20circle%20identities%20graphing%20multiple%20choice%20test%20format%20professional%20clean%20background&width=400&height=500&seq=actws066&orientation=portrait'
  },
];
